import React from 'react'
import { Grid, Typography} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { getAreasFisicasAction, getUsuarioAreaFisicaAction } from '../../../actions/usuarios/areasFisicas';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AreaFisica } from './AreaFisica';
import { useState } from 'react';
import { SubAreaFisica } from './SubAreaFisica';


const useStyles = makeStyles({
    root:{
        padding: 20,
        // maxWidth: 800,
        background:'#212121'
    },
    rootTitulo:{
        color: 'white',
        marginBottom: 10,
        textAlign: "center"
    }
});
  
const data = (values) => {
    const { idUsuario, idArea, idSubArea } = values || {};
    
    return {
        idUsuario: idUsuario || "",
        idArea: idArea || "",
        idSubArea: idSubArea || "",
    };
};

export const AreasFisicasMesaEntradas = ({title}) => {

    const classes = useStyles();
    const { areasFisicas, areaFisicaUsuario } = useSelector((state) => state.areasFisicas);  
  
    const { usuarioSeleccionado, seleccionado } = useSelector((state) => state.usuarios);
    const dispatch = useDispatch();

    const [values, setValues] = useState(data({
        idUsuario: usuarioSeleccionado.idUsuario,
        idArea: areaFisicaUsuario?.idArea,
        idSubArea: areaFisicaUsuario?.idSubArea
    }));

    const setearValores = (newValues) => {
        setValues(data({
            ...values,
            ...newValues
        }))
    };

    useEffect(() => {
        if (areaFisicaUsuario) {
          setValues(data({
            idUsuario: usuarioSeleccionado.idUsuario,
            idArea: areaFisicaUsuario.idArea,
            idSubArea: areaFisicaUsuario.idSubArea
          }));
        }
      }, [areaFisicaUsuario]);

    useEffect (() => {
        dispatch( getAreasFisicasAction() );
    }, [dispatch]);

    useEffect(() => {if(seleccionado) dispatch(getUsuarioAreaFisicaAction(usuarioSeleccionado.idUsuario))}, [usuarioSeleccionado]);

  return (
    <>
      <Typography component="h3" variant="h5" className={classes.rootTitulo}>{title}</Typography>
      <Grid item xs={12} >
            <Grid container item alignItems="center" className={classes.root} >
            {areasFisicas.map((area, index) => (
                        <AreaFisica 
                            key={index} 
                            area={area} 
                            values={values}
                            setearValores={setearValores}
                        />
                    ))}
            </Grid>
        </Grid>
        {areasFisicas.map((area, index) => {
                const areaSelected = area.idArea === values.idArea;
                const tieneSubAreas = area.subAreas.length > 0;

                if(areaSelected && tieneSubAreas) return (
                    <Grid item xs={12} >
                        <Grid container item alignItems="center" className={classes.root} >
                            <Grid item xs={12} >
                            <Typography component="h3" variant="h5" className={classes.rootTitulo}>SubPuestoTrabajo</Typography>
                            
                            </Grid>
                            {area.subAreas.map((subArea, indexSubArea) => (
                                <SubAreaFisica 
                                    key={indexSubArea} 
                                    subArea={subArea} 
                                    values={values}
                                    setearValores={setearValores}
                                />
                            ))}
                        </Grid>
                    </Grid>
                )

                return null
            })}
    </>
  )
}
